import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { FaYoutube, FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer() {
  return (
    <footer className="bg-black text-gray-400 px-10 py-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* Explore Section */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">Explore</h3>
          <ul className="space-y-2">
            <li><a href="#mission" className="hover:text-lime-400">Mission & Vision</a></li>
            <li><a href="#values" className="hover:text-lime-400">Our Values</a></li>
            <li><a href="#news" className="hover:text-lime-400">News & Events</a></li>
          </ul>
        </div>

        {/* Connect Section */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">Connect</h3>
          <ul className="space-y-2">
            <li><a href="#contact" className="hover:text-lime-400">Contact Us</a></li>
            <li><a href="#careers" className="hover:text-lime-400">Careers</a></li>
            <li><a href="#faq" className="hover:text-lime-400">FAQ</a></li>
          </ul>
        </div>

        {/* Address Section */}
        <div>
          <h3 className="text-white font-semibold mb-4 text-lg">Address</h3>
          <ul className="space-y-2">
            <li className="flex items-start gap-2">
              <FaMapMarkerAlt size={18} className="mt-1 text-lime-400 flex-shrink-0" />
              <span>Plot 1154/1598, Pradhan sahi, Raghunath nagar , Dumduma, Bhubaneswar, Odisha , India-751019</span>
            </li>
            <li className="flex items-center gap-2">
              <FaPhoneAlt size={16} className="text-lime-400" />
              <span>+91-7609066132, +91-6372797976</span>
            </li>
            <li className="flex items-center gap-2">
              <FaEnvelope size={16} className="text-lime-400" />
              <span>contact@acot.in</span>
            </li>
          </ul>
        </div>

       {/* Social Media Section */}
<div>
  <h3 className="text-white font-semibold mb-4 text-lg">Follow Us</h3>

  <div className="flex gap-4 mt-2 mb-6">
    <a
      href="https://www.youtube.com/@AjayaConservationTrust"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-lime-400 transition"
    >
      <FaYoutube size={28} />
    </a>

    <a
      href="https://www.linkedin.com/company/ajaya-conservation-trust/"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-lime-400 transition"
    >
      <FaLinkedin size={28} />
    </a>

    <a
      href="https://www.instagram.com/ajayaconservationtrust?igsh=MTEyOGhycmQ4MjJxcQ=="
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-lime-400 transition"
    >
      <FaInstagram size={28} />
    </a>

    <a
      href="https://x.com/ajaya_trust"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-lime-400 transition"
    >
      <FaXTwitter size={28} />
    </a>
  </div>

  {/* Office Location Map */}
  <h3 className="text-white font-semibold mb-3 text-lg">
    Our Location
  </h3>

  <div className="w-full max-w-sm h-40 rounded-lg overflow-hidden border border-gray-700">
    <iframe
      title="ACoT Office Location"
      src="https://www.google.com/maps?q=20.236038,85.789394&z=15&output=embed"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div>

      </div>

      {/* Bottom Copyright */}
      <div className="mt-10 text-center text-gray-500 text-sm">
        © {new Date().getFullYear()} ACoT | All Rights Reserved
      </div>
    </footer>
  );
}
